import { render, staticRenderFns } from "./MapSplitMatter.vue?vue&type=template&id=4d83cc61&scoped=true"
import script from "./MapSplitMatter.vue?vue&type=script&lang=ts"
export * from "./MapSplitMatter.vue?vue&type=script&lang=ts"
import style0 from "./MapSplitMatter.vue?vue&type=style&index=0&id=4d83cc61&prod&lang=scss&scoped=true"
import style1 from "./MapSplitMatter.vue?vue&type=style&index=1&id=4d83cc61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83cc61",
  null
  
)

export default component.exports